// extracted by mini-css-extract-plugin
export default {"content":"success-screen_content__rIdTZ","title":"success-screen_title__OP+bn","subtitle":"success-screen_subtitle__1louQ","button":"success-screen_button__+Vlqa"};